<mm-radio-control [parentForm]="parentForm" data-testid="recipientSelector"
    [radioModel]="isStandingAuthPage ? standingAuthRecipientModel : recipientModel">
</mm-radio-control>